import logger from "@/lib/logger/logger-init"
import { type CentraLanguageCode, validateLanguageCode } from "@/data/supported-languages"

/**
 * Retrieves the language code from a locale string and validates it.
 *
 * @param locale The locale string to extract the language code from.
 * @returns A valid language code if the extraction and validation succeed, otherwise
 *          undefined.
 */
export function getLangCode(locale: string): CentraLanguageCode | undefined {
    const code = locale.split("-")[0]
    const { success, output } = validateLanguageCode(code)

    if (success) {
        return output
    }

    logger.error(`Invalid locale sent to GetLangCode. Locale: ${locale}, Code: ${code}.`)

    return undefined
}
